export default __webpack_public_path__ + "static/media/tool-icon-shirt-blue-07.92772897.svg";